.page {
  display: grid;
  place-items: center;
  min-block-size: 70dvh;
  padding: var(--space-6);
  background: var(--md-surface);
}

.pageContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);
  max-inline-size: 32rem;
  text-align: center;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-3);
}

.heading:focus {
  outline: none;
}

.inline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-4);
  border-radius: var(--shape-md);
  background: var(--md-surface-container-low);
}
